import { authFetch } from '@/lib/api';

export async function swrFetcher(url) {
  const res = await authFetch(url);
  if (!res.ok) {
    const err = new Error('API error');
    err.status = res.status;
    throw err;
  }
  return res.json();
}
